import {
  SET_CAPTURE_TYPE,
  SET_DEVICE_LIST,
  SET_VIDEO_DEVICE,
  SET_AUDIO_DEVICE,
  SET_SHOW_COUNTDOWN,
  SET_MEDIA_PERMISSION,
  RECORDING_CODECS_BY_OS,
} from '../constants';

export type CaptureType = 'camera' | 'screen';

export interface RecordingCodecsPropsByOS {
  OSNameRegExMatch: string;
  camera: string;
  camera_screen: string;
  screen: string;
};

type Action =
  | { type: typeof SET_SHOW_COUNTDOWN; payload: boolean }
  | { type: typeof SET_VIDEO_DEVICE; payload: string }
  | { type: typeof SET_AUDIO_DEVICE; payload: string }
  | { type: typeof SET_DEVICE_LIST; payload: MediaDeviceInfo[] }
  | { type: typeof SET_CAPTURE_TYPE; payload: CaptureType | null }
  | { type: typeof SET_MEDIA_PERMISSION; payload: boolean }
  | { type: typeof RECORDING_CODECS_BY_OS; payload: RecordingCodecsPropsByOS[] };

type Dispatch = (action: Action) => void;

export type RecorderState = {
  mediaPermission: boolean;
  micAudio: boolean | unknown;
  captureType: CaptureType | null;
  recordingCodecsByOs: RecordingCodecsPropsByOS[];
  showCountdown: boolean;
  devices: {
    videoDevice: string;
    audioDevice: string;
    deviceList: MediaDeviceInfo[];
  };
  dispatch: Dispatch;
};

const micSettings = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
  channelCount: 2,
};

const initialState: RecorderState = {
  mediaPermission: false,
  showCountdown: true,
  micAudio: micSettings,
  captureType: 'camera',
  recordingCodecsByOs: [],
  devices: {
    videoDevice: 'default',
    audioDevice: 'default',
    deviceList: [],
  },
  dispatch: () => {},
};

const recorderReducer = (state: RecorderState, action: Action) => {
  switch (action.type) {
    case SET_SHOW_COUNTDOWN:
      return {
        ...state,
        showCountdown: action.payload,
      };
    case SET_VIDEO_DEVICE:
      return {
        ...state,
        devices: {
          ...state.devices,
          videoDevice: action.payload,
        },
      };
    case SET_AUDIO_DEVICE:
      return {
        ...state,
        devices: {
          ...state.devices,
          audioDevice: action.payload,
        },
      };
    case SET_DEVICE_LIST:
      return {
        ...state,
        devices: {
          ...state.devices,
          deviceList: action.payload,
        },
      };
    case SET_CAPTURE_TYPE:
      return {
        ...state,
        captureType: action.payload,
      };
    case SET_MEDIA_PERMISSION:
      return {
        ...state,
        mediaPermission: action.payload,
      };
    case RECORDING_CODECS_BY_OS:
      return {
        ...state,
        recordingCodecsByOs: action.payload,
      };
    default:
      return { ...state };
  }
};

export { recorderReducer, initialState };
